import { FC } from 'react';
import { useSpotlight } from '../model/useSpotlight';
import { SpotlightButton } from './SpotlightButton';
import { SpotlightDialog } from './SpotlightDialog';

export type SpotlightProps = {
  className?: string;
};

export const Spotlight: FC<SpotlightProps> = ({ className }) => {
  const { isOpen, open, close, shortcut } = useSpotlight();

  return (
    <>
      <SpotlightButton onOpen={open} className={className} shortcut={shortcut} />
      <SpotlightDialog isOpen={isOpen} onOpenChange={(next) => (next ? open() : close())} shortcut={shortcut} />
    </>
  );
};
